import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon"];
import React from 'react';
import styled from 'styled-components';
import { cssColorValue } from "../../styles";
export var Icon = styled(function Icon(_ref) {
  var IconComponent = _ref.icon,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(IconComponent, Object.assign({
    iconSize: 24
  }, props));
}).withConfig({
  displayName: "Icon",
  componentId: "sc-3c2j46-0"
})(["color:", ";"], cssColorValue('essentialBase'));